import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { WorkCenterType } from '../work-center-type'
import { WorkCenterTypeDetailComponent } from '../work-center-type-detail/work-center-type-detail.component'

@Component({
  selector: 'app-work-center-type-detail-side',
  templateUrl: './work-center-type-detail-side.component.html',
  styleUrls: ['./work-center-type-detail-side.component.scss'],
  imports: [WorkCenterTypeDetailComponent],
})
export class WorkCenterTypeDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workCenterType: WorkCenterType
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.workCenterType = this.route.snapshot.data['type']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
